/**
 * Tlačítko „±" vedle číselného pole.
 *
 * Číselná klávesnice iOS (`inputMode="decimal"`) nemá mínus, takže teplotu
 * mrazáku (−18 °C) na iPhonu nejde napsat. Tlačítko otočí znaménko
 * rozepsané hodnoty; prázdné pole začne mínusem.
 */

/** Může mít měření zápornou hodnotu? Teploty a body s limitem pod nulou. */
export function muzeZaporne(item) {
    const k = item?.mereni_kontext;
    const jednotka = k?.jednotka || item?.jednotka || item?.parametr?.jednotka || '';
    const meze = [k?.limit_min, k?.limit_max, item?.limit?.min_hodnota, item?.limit?.max_hodnota,
        item?.min_hodnota, item?.max_hodnota, item?.limit_min, item?.limit_max];
    return jednotka.includes('°') || meze.some(m => m != null && Number(m) < 0);
}

export function otocZnamenko(hodnota) {
    const s = String(hodnota ?? '').trim();
    if (s.startsWith('-') || s.startsWith('−')) return s.slice(1);
    return '-' + s;
}

export default function ZnamenkoTlacitko({ hodnota, onZmena, disabled, isDark, vyska = 36 }) {
    return (
        <button type="button" disabled={disabled} aria-label="Změnit znaménko"
            // Pole nesmí ztratit fokus — onBlur by uložil rozepsanou hodnotu
            onMouseDown={e => e.preventDefault()}
            onClick={e => { e.stopPropagation(); onZmena(otocZnamenko(hodnota)); }}
            style={{
                width: vyska, height: vyska, flexShrink: 0, borderRadius: 8, fontSize: 17, fontWeight: 700,
                lineHeight: 1, cursor: disabled ? 'default' : 'pointer', opacity: disabled ? 0.4 : 1,
                background: isDark ? 'rgba(255,255,255,0.06)' : 'var(--surface-base)',
                color: 'var(--text-primary)',
                border: `1.5px solid ${isDark ? 'rgba(255,255,255,0.12)' : 'var(--border-default)'}`,
            }}>
            ±
        </button>
    );
}
